import React, { useState, useEffect } from 'react';
import { 
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer 
} from 'recharts';
import { 
    Layers, TrendingUp, Filter, Loader2 
} from 'lucide-react';
import api from '../services/api';

const RelatoriosSetoresScreen = ({ currentUser }) => { 
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    
    const [startDate, setStartDate] = useState(firstDay.toISOString().split('T')[0]);
    const [endDate, setEndDate] = useState(today.toISOString().split('T')[0]);
    
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchReportData = async () => {
        setLoading(true);
        try {
            // MUDANÇA AQUI: Rota específica de Setores
            const response = await api.get('/reports/sectors', {
                params: { startDate, endDate }
            });
            setReportData(response.data || []);
        } catch (error) {
            console.error("Erro ao gerar relatório:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchReportData(); }, [startDate, endDate]);

    return (
        <div className="p-6 h-full overflow-y-auto bg-gray-50">
            <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
                <div>
                    <h2 className="text-2xl font-bold text-gray-800 flex items-center">
                        <Layers className="mr-2 text-orange-600" /> Performance por Setor
                    </h2>
                    <p className="text-sm text-gray-500">Análise de demanda por departamento</p>
                </div>

                <div className="flex gap-2 items-center bg-white p-2 rounded-lg shadow-sm border border-gray-200">
                    <Filter className="w-4 h-4 text-gray-500" />
                    <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="p-1.5 border rounded text-sm"/>
                    <span className="text-gray-400">-</span>
                    <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="p-1.5 border rounded text-sm"/>
                    <button onClick={fetchReportData} className="p-1.5 bg-orange-100 text-orange-700 rounded hover:bg-orange-200">
                        {loading ? <Loader2 className="w-4 h-4 animate-spin"/> : <TrendingUp className="w-4 h-4"/>}
                    </button>
                </div>
            </div>

            {/* GRÁFICO */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 mb-8">
                <h3 className="font-bold text-gray-700 mb-4">Volume por Setor</h3>
                <div className="h-80">
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={reportData}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} />
                            <XAxis dataKey="name" tick={{fontSize: 12}} />
                            <YAxis />
                            <Tooltip />
                            <Bar dataKey="total" name="Atendimentos" fill="#F97316" radius={[4, 4, 0, 0]} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>

            {/* TABELA */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                <table className="w-full text-sm text-left">
                    <thead className="bg-gray-50 border-b uppercase text-xs text-gray-500">
                        <tr>
                            <th className="px-6 py-3">Setor</th>
                            <th className="px-6 py-3 text-center">Total</th>
                            <th className="px-6 py-3 text-center">Resolvidos</th>
                            <th className="px-6 py-3 text-center">% Eficiência</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {reportData.length > 0 ? (
                            reportData.map((item, idx) => (
                                <tr key={idx} className="hover:bg-gray-50">
                                    <td className="px-6 py-4 font-bold text-gray-700">{item.name}</td>
                                    <td className="px-6 py-4 text-center font-bold">{item.total}</td>
                                    <td className="px-6 py-4 text-center text-green-600">{item.ended}</td>
                                    <td className="px-6 py-4 text-center">
                                        <span className={`px-2 py-1 rounded text-xs font-bold ${item.rate > 70 ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>
                                            {item.rate}%
                                        </span>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr><td colSpan="4" className="text-center py-8 text-gray-400">Nenhum dado.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default RelatoriosSetoresScreen;